import { render, staticRenderFns } from "./PageTable.vue?vue&type=template&id=7f439d96&scoped=true"
import script from "./PageTable.vue?vue&type=script&lang=js"
export * from "./PageTable.vue?vue&type=script&lang=js"
import style0 from "./PageTable.vue?vue&type=style&index=0&id=7f439d96&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f439d96",
  null
  
)

export default component.exports